import { ApiResult, HttpClient } from "../http.js";

/** A reusable quote description template (port of Firestore QUOTE_DESCRIPTION_TEMPLATES). */
export interface QuoteTemplateDto {
  id: string;
  orgId: string;
  category: string;
  name: string;
  description: string;
  defaultUnit: string | null;
  defaultUnitPrice: number | null;
  priceLibraryItemId: string | null;
  /** Resolved from the linked price library item by the list read path (null when unlinked or item archived/deleted). */
  libraryUnit: string | null;
  librarySalesPricePerUnit: number | null;
  createdById: string | null;
  createdByName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateQuoteTemplatePayload {
  category: string;
  name: string;
  description: string;
  defaultUnit?: string | null;
  defaultUnitPrice?: number | null;
  priceLibraryItemId?: string | null;
  id?: string;
}

export interface UpdateQuoteTemplatePayload {
  category?: string | null;
  name?: string | null;
  description?: string | null;
  defaultUnit?: string | null;
  defaultUnitPrice?: number | null;
  priceLibraryItemId?: string | null;
  /** Clear the optional defaults back to null (the API leaves null fields unchanged otherwise). */
  clearDefaultUnit?: boolean;
  clearDefaultUnitPrice?: boolean;
  clearPriceLibraryItem?: boolean;
}

export class QuoteTemplatesApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<QuoteTemplateDto[]>> {
    return this.http.get<QuoteTemplateDto[]>("/api/quote-templates");
  }

  create(payload: CreateQuoteTemplatePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/quote-templates", { body: payload });
  }

  update(id: string, payload: UpdateQuoteTemplatePayload): Promise<ApiResult<QuoteTemplateDto>> {
    return this.http.put<QuoteTemplateDto>(`/api/quote-templates/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/quote-templates/${encodeURIComponent(id)}`);
  }
}
